import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {StoreService} from "../../../../shared/services/store.service";
import {CartService} from "../../../../shared/services/cart.service";
import {Meta} from "@angular/platform-browser";
import {MessageService} from "primeng/api";
import {MainDataService} from "../../../../shared/services/main-data.service";
import {TranslateService} from "@ngx-translate/core";
import {NavigationEnd, Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service";
import {AuthService} from "../../../../shared/services/auth.service";
import {AuthTokenService} from "../../../../shared/services/token.service";
import {ConfigurationKeys} from "../../../../enums/sections";
import {TenantService} from "../../services/tenant.service";
import {AppDataService} from "../../../../shared/services/app-data.service";
import {Categories, Configuration, InitialData, TenantRecords} from "../../../../interfaces/app";
import {v4 as uuidv4} from "uuid";
import * as CryptoJS from "crypto-js";
import {LanguageService} from "../../../../shared/services/language.service";


class GuidGenerator {
  static newGuid() {
   return  uuidv4()
  }
}


@Component({
  selector: 'app-main-landing',
  templateUrl: './main-landing.component.html',
  styleUrls: ['./main-landing.component.scss']
})
export class MainLandingComponent implements OnInit {
  @ViewChild('scroll', {read: ElementRef}) public scroll!: ElementRef<any>;
  lang: string = 'en';
  storeNames: Array<any> = [];
  display: boolean = true;
  loading: boolean = false;
  themeApplied: boolean;
  seoTitle: string = '';
  seoDesc: string = '';
  isShop: boolean = false;
  isRefreshTokenCalled: boolean = false;
  isRenderApplication: boolean = false;
  bg_color: any;
  cartListCount: any = 0;
  cartListData: any = [];
  public country: string = '';

  constructor(private store: StoreService,
              private cartService: CartService,
              private meta: Meta,
              private messageService: MessageService,
              private mainDataService: MainDataService,
              private translate: TranslateService,
              private router: Router,
              private cookieService: CookieService,
              private authService: AuthService,
              private authTokenService: AuthTokenService,
              private cd: ChangeDetectorRef,
              private tenantService: TenantService,
              private appDataService: AppDataService,private languageService:LanguageService) {
    translate.addLangs(['en', 'ar']);
    this.themeApplied = false;

    translate.setDefaultLang('en');


  }

  ngOnInit(): void {

    const sessionId = window.localStorage.getItem('sessionId');
    if (!sessionId) {
      localStorage.setItem('sessionId', GuidGenerator.newGuid());
    }

      this.triggerInitialCalls();

  }

  triggerInitialCalls() {
    this.routeToTop();
    this.createStores();
    // this.getCategories()
    // this.lang = this.store.get('lang') || 'en';
    this.setLangSettings();
    this.getMainData();

  }

  routeToTop(): void {
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  createStores(): void {
    this.storeNames = [


      {name: 'timeInterval', data: null, localStore: true},
      {name: 'orderData', data: null, localStore: true},
      {name: 'transactionData', data: null, localStore: true},
      {name: 'userPhone', data: null, localStore: true},
      {name: 'mainData', data: null, localStore: true},
      {name: 'allCountryTenants', data: null, localStore: true},
      {name: 'tenantId', data: null, localStore: true},
      {name: 'shipmentCost', data: null, localStore: true},
      {name: 'isShop', data: null, localStorage: true},
      {name: 'currency', data: null, localStore: true},
      {name: 'countryCode', data: null, localStore: true},
      {name: 'countryPhone', data: null, localStore: true},
      {name: 'profile', data: null, localStore: true},
      {name: 'categories', data: [], localStore: true},
      {name: 'notifications', data: null, localStore: false},
      {name: 'cartProducts', data: [], localStore: true},
      {name: 'favouritesProducts', data: [], localStore: true},
      {name: 'compareProducts', data: [], localStore: true},
      {name: 'cartProductSuccess', data: null, localStore: false},
      {name: 'favouritesProductSuccess', data: null, localStore: false},
      {name: 'compareProductSuccess', data: null, localStore: false},
      {name: 'allowedFeature', data: null, localStore: false},
      {
        name: 'checkoutData',
        data: {
          shipping: null,
          payment: null,
          promo: null,
          steps: null,
          profile: null,
          orderId: null,
        },
        localStore: true,
      },
      {name: 'search', data: '', localStore: false},
      {name: 'loading', data: false, localStore: true},
      {name: 'verificationCode', data: '', localStore: true},
    ];

    /*Create Dynamic BehaviorSubject at Store*/
    this.storeNames.forEach((item) => {
      this.store.createNewStore(item.name, item.data, item.localStore);
    });
  }

  setLangSettings(): void {
    // Api Call commented on 27/11/2023 war room meeting
    // this.languageService.getLanguage().subscribe((res:any)=>{
    //
    //     })
    let lang:any =localStorage.getItem('lang');
    // if(lang){
    //   this.translate.setDefaultLang(lang);
    //   this.translate.use(lang);
    //   document.documentElement.setAttribute(
    //     'dir',
    //     lang === 'ar' ? 'rtl' : 'ltr'
    //   );
    // }

  }

  getConfigurationDecimal() {
    const configuration: Configuration = this.appDataService.configuration
    this.isRenderApplication = true;
    if (configuration.records?.length > 0) {
      let records = configuration.records;
      let decimalValue = records.find(
        (x: any) => x.key == ConfigurationKeys.CurrencyDecimal
      );
      let countryPhoneNumber = records.find(
        (x: any) => x.key == ConfigurationKeys.CountryPhone
      );
      let phoneLength = records.find(
        (x: any) => x.key == ConfigurationKeys.PhoneLength
      );
      let phoneNumberMask = records.find(
        (x: any) => x.key == ConfigurationKeys.PhoneNumberMask
      );
      let currencyValue = records.find(
        (x: any) => x.key == ConfigurationKeys.Currency
      );

      let emailRequired = records.find(
        (x: any) => x.key == ConfigurationKeys.EmailRequired
      );
      let disableCent = records.find(
        (x: any) => x.key == ConfigurationKeys.DisableCents
      );

      let customerAddressLandmarkRequired = records.find(
        (x: any) =>
          x.key == ConfigurationKeys.CustomerAddressLandmarkRequired
      );
      if (decimalValue)
        localStorage.setItem('decimalValue', decimalValue.value);
      if (countryPhoneNumber)
        localStorage.setItem('countryPhone', countryPhoneNumber.value);
      if (phoneLength)
        localStorage.setItem('PhoneLength', phoneLength.value);
      if (phoneNumberMask)
        localStorage.setItem('PhoneNumberMask', phoneNumberMask.value);
      if (currencyValue)
        localStorage.setItem('currency', currencyValue.value);
      if (customerAddressLandmarkRequired)
        localStorage.setItem(
          'customerAddressLandmarkRequired',
          customerAddressLandmarkRequired.value
        );
      if (emailRequired) {
        localStorage.setItem('emailRequired', emailRequired.value);
      } else {
        localStorage.setItem('emailRequired', 'false');
      }
      if (disableCent) {
        localStorage.setItem('disableCent', disableCent.value);
      } else {
        localStorage.setItem('disableCent', 'false');
      }
    }
    // this.getCart();
    this.getAllCountryTenants();
    this.getCategories();
    this.isRenderApplication = true;
  }

  getCart(): void {
    let sessionId = localStorage.getItem('sessionId') || '';

    this.cartService.getCart(sessionId).subscribe({
      next: (res: any) => {
        this.cartListCount = 0;
        this.cartListData = [];
        if (res?.data?.records?.length) {
          this.cartListCount = 0;
          if (res.data.records[0].cartDetails.length) {
            this.cartListCount = res.data.records[0].cartDetails.length;
            this.cartListData = res.data.records[0].cartDetails;

          }
          if (res.data.records[0].cartDetailsDPay && res.data.records[0].cartDetailsDPay.length) {
            this.cartListCount += res.data.records[0].cartDetailsDPay.length;
            this.cartListData = this.cartListData.concat(res.data.records[0].cartDetailsDPay)
          }
          this.mainDataService.setCartLenghtData(this.cartListCount);
          this.mainDataService.setCartItemsData(this.cartListData);

        } else {
          this.mainDataService.setCartLenghtData(0);
          this.mainDataService.setCartItemsData([]);
        }
      },
      error: (err: any) => {
      },
      complete: () => {
      }
    });
  }

  getMainData(): void {
    this.getInitialDataConfig()
  }

  getInitialDataConfig() {
    const initialData: InitialData = this.appDataService.initialData
    this.getConfigurationDecimal();
    if(initialData.featureByTenantRes.length){
      localStorage.setItem('Allowed-feature', JSON.stringify(initialData.featureByTenantRes));
      let featureList : any = localStorage.getItem('Allowed-feature')
      featureList = JSON.parse(featureList);
      let isSellerHub = featureList.find((item : any) => item.portalName === 'Seller-Hub');
      if(isSellerHub){
        localStorage.setItem('isSellerHub', 'seller-hub')
      }else{
        localStorage.setItem('isSellerHub', 'not-seller-hub')
      }
    }else{
      localStorage.setItem('isSellerHub', 'not-seller-hub')
    }
    this.store.set('allowedFeature', initialData.featureByTenantRes)
    if (initialData.result.records != undefined) {
      this.store.set('mainData', initialData.result.records);
      Object.entries(initialData.result.records).forEach(([subkey, value]) => {
        if (initialData.result.records[parseInt(subkey)].key == 'AppTheme') {
          const dynamicStyle = initialData.result.records[parseInt(subkey)].displayName;
          if (dynamicStyle != null && dynamicStyle != '') {
            const dynamicStyleObj = JSON.parse(dynamicStyle);
            this.applyStyle(dynamicStyleObj);
          }
        } else {
          this.themeApplied = true;
          this.cd.detectChanges();
        }
        this.tenantService.setHeader(true)
      });
    }
    this.isShop = initialData.isShop;

    if (this.isShop == true) {
      this.seoTitle = initialData.shopProductSetting.seoTitle;
      this.seoDesc = initialData.shopProductSetting.seoDescription;

      this.meta.updateTag({name: this.seoTitle, content: this.seoDesc});
    } else {
      this.meta.updateTag({
        name: 'Description',
        content: 'MarketPlace,Buy,products',
      });
    }
  }

  getCategories(): void {
    const categories: Categories = this.appDataService.categories;
    if (categories.records != undefined) {
      this.store.set('categories', categories.records);
      localStorage.setItem('allCategories', JSON.stringify(categories.records));
    }
  }

  getAllCountryTenants(): void {
    const tenants = this.appDataService.tenants
    if (tenants.records != undefined) {
      let tenantId = localStorage.getItem('tenantId');
      let data = tenants.records;
      let arr: TenantRecords = data.find((element: any) => element.tenantId == tenantId) ?? new TenantRecords();
      localStorage.setItem('isoCode', arr?.isoCode);
      this.store.set('allCountryTenants', tenants.records);
    }
  }

  appendCssPropertyValue(
    key: any,
    value: any,
    dynamicStyleObj: any,
    sub: boolean
  ) {
    if (value) {
      Object.entries(value).forEach(([subKey, subSubValue]) => {
        if (value[subKey]) {
          document.documentElement.style.setProperty(
            '--' + subKey,
            value[subKey]
          );
        } else if (subKey && dynamicStyleObj && dynamicStyleObj[key]) {
          this.appendCssPropertyValue(
            subKey,
            dynamicStyleObj[key][subKey],
            dynamicStyleObj,
            true
          );
        }
      });
    }
  }

  applyStyle(dynamicStyleObj: any) {

    Object.entries(dynamicStyleObj).forEach(([key, value]) => {
      if (
        value &&
        dynamicStyleObj[key] &&
        (dynamicStyleObj[key]?.length > 2 ||
          Object.entries(dynamicStyleObj[key])?.length >= 1)
      ) {
        if (
          dynamicStyleObj[key] != null &&
          (dynamicStyleObj[key][0]?.length == 1 ||
            Number(dynamicStyleObj[key][0]))
        ) {
          document.documentElement.style.setProperty(
            '--' + key,
            dynamicStyleObj[key]
          );
        } else {
          this.appendCssPropertyValue(
            key,
            dynamicStyleObj[key],
            dynamicStyleObj,
            false
          );
        }
      } else {
        document.documentElement.style.setProperty(
          '--' + key,
          dynamicStyleObj[key]
        );
      }
    });
    this.themeApplied = true;
    this.cd.detectChanges();

  }

  signOut(): void {
    this.setStoreData();
    this.authTokenService.authTokenSet('');
    this.cookieService.delete('authToken', window.location.hostname);

    this.store.set('cartProducts', '');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('auth_enc');
    this.router.navigate(['/login']);


    sessionStorage.clear();

    this.store.set('profile', '');
    this.store.set('cartProducts', '');
    localStorage.setItem('sessionId', '');
    localStorage.setItem('addedProducts', '');
    this.getMainData();
  }

  setStoreData(): void {
    if (this.store.localStoreNames.length) {

      this.store.set('refreshToken', null);
      this.store.set('profile', null);
      this.store.set('cartProducts', []);
      this.store.set('favouritesProducts', []);
      this.store.set('compareProducts', []);
      this.store.set('socialAccount', null);
      this.store.set('XXSRFTOKEN', null);
      this.store.set('notifications', {
        notifications: [],
        unreadNotifications: 0,
      });
      this.store.set('checkoutData', {
        shipping: null,
        payment: null,
        promo: null,
        steps: null,
        profile: null,
        orderId: null,
      });
    } else {

      localStorage.setItem('timeInterval', '');
      localStorage.setItem('TenantId', '');
      localStorage.setItem('userPhone', '');
      localStorage.setItem('profile', '');
      localStorage.setItem('cartProducts', JSON.stringify([]));
      localStorage.setItem('favouritesProducts', JSON.stringify([]));
      localStorage.setItem('compareProducts', JSON.stringify([]));
      localStorage.setItem('XXSRFTOKEN', '');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('auth_enc');
    }
  }

  scrollToTop() {
    this.scroll.nativeElement.scrollTop = 0;
  }
}
